export type ProjectContext = {
  id: number;
  code: string;
  name: string;
  role?: string;
};

const STORAGE_KEY = 'assertion.activeProjectId';
const EVENT_NAME = 'assertion-project-change';

export function getActiveProjectId(): number | null {
  if (typeof window === 'undefined') return null;
  const value = Number(window.localStorage.getItem(STORAGE_KEY));
  return Number.isFinite(value) && value > 0 ? value : null;
}

export function setActiveProject(project: ProjectContext): void {
  window.localStorage.setItem(STORAGE_KEY, String(project.id));
  window.dispatchEvent(new CustomEvent<ProjectContext>(EVENT_NAME, { detail: project }));
}

export function clearActiveProject(): void {
  window.localStorage.removeItem(STORAGE_KEY);
}

export function subscribeProjectChange(listener: (project: ProjectContext) => void): () => void {
  const handler = (event: Event) => listener((event as CustomEvent<ProjectContext>).detail);
  window.addEventListener(EVENT_NAME, handler);
  return () => window.removeEventListener(EVENT_NAME, handler);
}
